import { Button, makeStyles, MenuItem } from "@fluentui/react-components";
import { Link } from "react-router-dom";

interface IMenuLinkProps {
    to: string;
    label: string;
    primary?: boolean;
}

const useStyles = makeStyles({
    button: {
        padding: "10px",
    },
    link: {
        textDecoration: "none",
        color: "inherit",
        display: "block",
        width: "100%"
    }
});

const MenuLink = (props: IMenuLinkProps) => {
    const { to, label, primary } = props;
    const styles = useStyles();

    const appearance = primary ? "primary" : "subtle";

    return (
        <Link to={to} className={styles.link}>
            <Button type="button" appearance={appearance} className={styles.button}>
                {label}
            </Button>
        </Link>
    );
};

export default MenuLink;